import { render, staticRenderFns } from "./playScreen.vue?vue&type=template&id=d98500ea&scoped=true&"
import script from "./playScreen.vue?vue&type=script&lang=js&"
export * from "./playScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98500ea",
  null
  
)

export default component.exports